import type { OnboardingGoalQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";

export enum SidebarHubTaskStatus {
    Completed = "Completed",
    NotStarted = "NotStarted",
}

enum SidebarHubTaskIntegration {
    Salesforce = "salesforce",
    Hubspot = "hubspot",
}

export interface SidebarHubTaskMetadata {
    integratedCrm?: SidebarHubTaskIntegration[];
    opportunityList?: string;
    savedSearch?: string;
}

export interface SidebarHubTaskItem {
    taskType: OnboardingGoalQuestionType;
    status: SidebarHubTaskStatus;
    createdAt: string;

    metadata?: SidebarHubTaskMetadata;
}

export interface SidebarHubTasksDto {
    accountId: number;
    onboardingTasks: SidebarHubTaskItem[];
    userId: number;
}
